export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Tagesertrag',
            backgroundColor: 'rgba(245, 158, 11, 0.75)',  // warm amber — solar theme
            borderColor: 'rgba(217, 119, 6, 0.9)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(245, 158, 11, 0.95)',
            hoverBorderColor: 'rgba(217, 119, 6, 1)',
            borderRadius: 3,
            data: [0]
        }
    ]
};
